"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalHeader = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isReactFragment = require("../utils/isReactFragment");
var _IconButton = require("../IconButton/IconButton");
var _clamp = require("../utils/_clamp");
var _useUniqueId = require("../utils/useUniqueId");
var _messages = require("../utils/messages");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
var _excluded = ["closeLabel", "closeButton", "className", "children", "customBackAction", "customCloseAction", "draggable", "titleId", "subheadId", "onHide", "updateStyle", "containerRef", "modalContentId"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-modal';
var MOVEMENT_STEP_SIZE = 16;
var ModalHeader = exports.ModalHeader = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _containerRef$current;
  var closeLabel = props.closeLabel,
    _props$closeButton = props.closeButton,
    closeButton = _props$closeButton === void 0 ? false : _props$closeButton,
    className = props.className,
    children = props.children,
    customBackAction = props.customBackAction,
    customCloseAction = props.customCloseAction,
    draggable = props.draggable,
    titleId = props.titleId,
    subheadId = props.subheadId,
    onHide = props.onHide,
    updateStyle = props.updateStyle,
    containerRef = props.containerRef,
    modalContentId = props.modalContentId,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Modal.default);
  var instructionsId = (0, _useUniqueId.useUniqueId)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = (0, _react.useState)({
      startX: 0,
      startY: 0,
      x: 0,
      y: 0,
      pageX: 0
    }),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var dialogClientRect = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
  var getDialogNode = function getDialogNode() {
    var _document;
    return (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(modalContentId);
  };
  var contentClientRect = function contentClientRect() {
    var _getDialogNode;
    return (_getDialogNode = getDialogNode()) === null || _getDialogNode === void 0 ? void 0 : _getDialogNode.getBoundingClientRect();
  };
  var titleRef = (0, _react.useRef)();
  var subHeadRef = (0, _react.useRef)();
  var getContentTop = function getContentTop() {
    var _contentClientRect;
    return ((_contentClientRect = contentClientRect()) === null || _contentClientRect === void 0 ? void 0 : _contentClientRect.top) || 0;
  };
  var getContentBottom = function getContentBottom() {
    var _contentClientRect2;
    return ((_contentClientRect2 = contentClientRect()) === null || _contentClientRect2 === void 0 ? void 0 : _contentClientRect2.bottom) || 0;
  };
  var getContentLeft = function getContentLeft() {
    var _contentClientRect3;
    return ((_contentClientRect3 = contentClientRect()) === null || _contentClientRect3 === void 0 ? void 0 : _contentClientRect3.left) || 0;
  };
  var getContentRight = function getContentRight() {
    var _contentClientRect4;
    return ((_contentClientRect4 = contentClientRect()) === null || _contentClientRect4 === void 0 ? void 0 : _contentClientRect4.right) || 0;
  };
  var getContentWidth = function getContentWidth() {
    var _contentClientRect5;
    return ((_contentClientRect5 = contentClientRect()) === null || _contentClientRect5 === void 0 ? void 0 : _contentClientRect5.width) || 0;
  };
  var getContentX = function getContentX() {
    var _contentClientRect6;
    return ((_contentClientRect6 = contentClientRect()) === null || _contentClientRect6 === void 0 ? void 0 : _contentClientRect6.x) || 0;
  };
  var onMouseDown = (0, _react.useCallback)(function (e) {
    var _e$persist, _titleRef$current, _subHeadRef$current;
    e === null || e === void 0 || (_e$persist = e.persist) === null || _e$persist === void 0 || _e$persist.call(e);
    if (e.button !== 0 || titleRef !== null && titleRef !== void 0 && (_titleRef$current = titleRef.current) !== null && _titleRef$current !== void 0 && _titleRef$current.contains(e.target) || subHeadRef !== null && subHeadRef !== void 0 && (_subHeadRef$current = subHeadRef.current) !== null && _subHeadRef$current !== void 0 && _subHeadRef$current.contains(e.target)) {
      return;
    }
    if (typeof (draggable === null || draggable === void 0 ? void 0 : draggable.onDragStart) === 'function') {
      draggable.onDragStart(e);
    }
    setIsDragging(true);
    setPosition(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        startX: e.pageX - prevState.x,
        startY: e.clientY - prevState.y,
        startLeft: (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) && parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10),
        startLeftEdge: getContentX(),
        startRightEdge: getContentX() + getContentWidth(),
        pageX: e.pageX,
        clientY: e.clientY
      });
    });
  });
  var onKeyDown = (0, _react.useCallback)(function (e) {
    var _e$persist2;
    e === null || e === void 0 || (_e$persist2 = e.persist) === null || _e$persist2 === void 0 || _e$persist2.call(e);
    var moveStepSize = e.shiftKey ? 5 * MOVEMENT_STEP_SIZE : MOVEMENT_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        e.preventDefault();
        if (getContentLeft() > 0) {
          setPosition(function (prevState) {
            var newLeft = prevState.x - Math.min(moveStepSize, getContentLeft());
            updateStyle === null || updateStyle === void 0 || updateStyle({
              top: "".concat(prevState.y, "px"),
              left: "".concat(newLeft, "px")
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.right:
        e.preventDefault();
        if (getContentRight() < window.innerWidth) {
          setPosition(function (prevState) {
            var newLeft = prevState.x + Math.min(moveStepSize, window.innerWidth - getContentRight());
            updateStyle === null || updateStyle === void 0 || updateStyle({
              top: "".concat(prevState.y, "px"),
              left: "".concat(newLeft, "px")
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.up:
        e.preventDefault();
        if (getContentTop() > 0) {
          setPosition(function (prevState) {
            var newTop = prevState.y - Math.min(moveStepSize, getContentTop());
            updateStyle === null || updateStyle === void 0 || updateStyle({
              top: "".concat(newTop, "px"),
              left: "".concat(prevState.x, "px")
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              y: newTop
            });
          });
        }
        break;
      case _keycode.default.codes.down:
        e.preventDefault();
        if (getContentBottom() < window.innerHeight) {
          setPosition(function (prevState) {
            var newTop = prevState.y + Math.min(moveStepSize, window.innerHeight - getContentBottom());
            updateStyle === null || updateStyle === void 0 || updateStyle({
              top: "".concat(newTop, "px"),
              left: "".concat(prevState.x, "px")
            });
            return _objectSpread(_objectSpread({}, prevState), {}, {
              y: newTop
            });
          });
        }
        break;
      default:
    }
    if (typeof (draggable === null || draggable === void 0 ? void 0 : draggable.onKeyDown) === 'function') {
      draggable.onKeyDown(e);
    }
  });
  (0, _useUniversalLayoutEffect.default)(function () {
    // set default vertical positioning
    // needs delay due to fade in .3s transition
    var positioningTimer = setTimeout(function () {
      setPosition(function (prevState) {
        var _containerRef$current2;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          y: containerRef === null || containerRef === void 0 || (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || (_containerRef$current2 = _containerRef$current2.getBoundingClientRect()) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.top
        });
      });
    }, 300);
    return function () {
      clearTimeout(positioningTimer);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var onMouseMove = function onMouseMove(e) {
      var _e$persist3;
      e === null || e === void 0 || (_e$persist3 = e.persist) === null || _e$persist3 === void 0 || _e$persist3.call(e);
      var xDisplacement = e.pageX - position.pageX;
      var yDisplacement = e.clientY - position.startY;
      xDisplacement = (0, _clamp.clamp)(xDisplacement, -position.startLeftEdge, window.innerWidth - position.startRightEdge);
      yDisplacement = (0, _clamp.clamp)(yDisplacement, 0, window.innerHeight - dialogClientRect.height);
      var startLeft = position.startLeft + xDisplacement;
      updateStyle === null || updateStyle === void 0 || updateStyle({
        top: "".concat(yDisplacement, "px"),
        left: "".concat(startLeft, "px")
      });
      setPosition(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          x: startLeft,
          y: yDisplacement,
          pageX: e.pageX,
          clientY: e.clientY,
          startLeft: startLeft
        });
      });
    };
    var onMouseUp = function onMouseUp(e) {
      var _e$persist4;
      e === null || e === void 0 || (_e$persist4 = e.persist) === null || _e$persist4 === void 0 || _e$persist4.call(e);
      setIsDragging(false);
      if (typeof (draggable === null || draggable === void 0 ? void 0 : draggable.onDragEnd) === 'function') {
        draggable.onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return function () {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging]);
  (0, _react.useEffect)(function () {
    if (!draggable) return function () {};
    // try to keep the modal within the window when
    // window resizes

    var handleWindowResize = function handleWindowResize() {
      if (!(containerRef !== null && containerRef !== void 0 && containerRef.current)) {
        return;
      }
      var skipLeftMovement;
      if (getContentWidth() >= window.innerWidth && getContentLeft() <= 0) {
        skipLeftMovement = true;
      }
      var newLeft = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10);
      var newTop = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('top').replace('px', ''), 10);
      if (window.innerWidth <= getContentRight() && getContentLeft() > 0) {
        newLeft -= getContentRight() - window.innerWidth;
      } else if (getContentLeft() < 0) {
        newLeft -= getContentLeft();
      }
      if (window.innerHeight <= getContentBottom() && getContentTop() > 0) {
        newTop -= getContentBottom() - window.innerHeight;
      }
      setPosition(function (prevState) {
        updateStyle === null || updateStyle === void 0 || updateStyle({
          left: "".concat(skipLeftMovement ? prevState.left : newLeft, "px"),
          top: "".concat(newTop, "px")
        });
        return _objectSpread(_objectSpread({}, prevState), {}, {
          x: newLeft,
          y: newTop
        });
      });
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [draggable]);
  var headerClasses = classnames("".concat(CSS_BLOCK, "__header"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__header--draggable"), draggable), "".concat(CSS_BLOCK, "__header--dragging"), isDragging), className);
  var _renderChildren = function _renderChildren(childNodes) {
    var _context;
    return (0, _map.default)(_context = _react.default.Children).call(_context, childNodes, function (child) {
      var _child$type, _child$type2;
      if ((0, _isReactFragment.isReactFragment)(child)) {
        return _renderChildren(child.props.children);
      }
      if ((child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Modal.Title') {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          id: titleId,
          ref: child.ref ? (0, _reactMergeRefs.default)([titleRef, child.ref]) : titleRef
        });
      }
      if ((child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Modal.Subhead') {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          id: subheadId,
          ref: child.ref ? (0, _reactMergeRefs.default)([subHeadRef, child.ref]) : subHeadRef
        });
      }
      return child;
    });
  };
  var additionalProps = draggable ? _objectSpread(_objectSpread({}, otherProps), {}, {
    onMouseDown: onMouseDown,
    onKeyDown: onKeyDown,
    role: 'button',
    tabIndex: '0',
    'aria-describedby': instructionsId
  }) : otherProps;
  var closeButtonToRender = customCloseAction || closeButton && /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    ariaLabel: closeLabel,
    className: classnames("".concat(CSS_BLOCK, "__close")),
    iconName: "close",
    iconProps: {
      forceSize: 'xs-plus'
    },
    muted: true,
    onClick: onHide,
    tooltipDelay: -1
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, additionalProps, {
    className: headerClasses,
    ref: ref
  }), draggable && /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    className: classnames("".concat(CSS_BLOCK, "__screen-reader-only")),
    id: instructionsId
  }, draggable.screenReaderInstructions), customBackAction ? /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "__action-title"))
  }, customBackAction, _renderChildren(children)) : _renderChildren(children), !draggable && closeButtonToRender), draggable && closeButtonToRender);
});
var propTypes = {
  /** Content of the modal header. */
  children: _propTypes.default.any,
  /** Custom classes to add to the header's `<div>` tag. */
  className: _propTypes.default.string,
  /** If true, the modal will display a close button. */
  closeButton: _propTypes.default.bool,
  // TODO: figure out how to use JSDoc on custom prop type validators
  // eslint-disable-next-line valid-jsdoc
  /** Provides an accessible label for the close button. Required when `closeButton` is true. */
  // eslint-disable-next-line consistent-return
  closeLabel: function closeLabel(props, propName, componentName) {
    if (props.closeButton && (!props[propName] || typeof props[propName] !== 'string')) {
      var _context2, _context3;
      return new Error((0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "The prop ".concat(propName, " is required in ")).call(_context3, componentName, " when `closeButton` is true. ")).call(_context2, (0, _messages.LOCALIZED_TEXT_MESSAGE)('CoreUIComponents.close')));
    }
  },
  /** Custom action/button to be rendered to the left of the modal title
   * for actions like 'back'. */
  customBackAction: _propTypes.default.node,
  /** Custom action/button to be rendered instead of the default close button. */
  customCloseAction: _propTypes.default.node,
  /** @ignore */
  containerRef: _propTypes.default.object,
  /** @ignore */
  draggable: _propTypes.default.shape({
    screenReaderInstructions: _propTypes.default.string.isRequired,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** @ignore */
  subheadId: _propTypes.default.string,
  /** @ignore */
  titleId: _propTypes.default.string,
  /** @ignore */
  updateStyle: _propTypes.default.func,
  /** @ignore */
  modalContentId: _propTypes.default.string,
  /** @ignore Fired when the modal is dismissed. Set by Modal when this is a direct child. */
  onHide: _propTypes.default.func
};
ModalHeader.displayName = 'Modal.Header';
ModalHeader.propTypes = propTypes;
var _default = exports.default = ModalHeader;